import { injectReducer } from 'common/reducers'

export default store => ({
  path: ':id',
  getComponent: async function (nextState, cb) {
    const [module, reducer] = await Promise.all([
      import('./containers/ChannelContainer'),
      import('./reducers')
    ])

    injectReducer(store, { key: 'channel', reducer: reducer.default })

    cb(null, module.default)
  }
})
